<template>
</template>
<script type="text/javascript">

//请求成功
const errorCode = 'ERRORCODE0000'

//未查询到记录
const errorCode20 = 'ERRORCODE0020'

//首次登陆，强制修改密码
const errorCode03 = 'ERRORCODE0003'
//未查询到记录
const errorCode04 = 'ERRORCODE0004'
//用户被锁定
const errorCode31 = 'ERRORCODE0031'

//添加的比较数据重复
const ERROR_CODE_COMPARE_REPEAT = 'ERRORCODE0012'

//最多可比较的数量
const COMPARE_MOST = 5

//网络异常提示
const ERROR_MESSAGE = '网络错误，请重试'

/**
 * login.vue   HomeOutside.vue
 */
//帐号不能为空
const LOGIN_NAME_MESSAGE = '帐号不能为空!'
//帐号长度在3-10位
const LOGIN_NAME_LENGTH_MESSAGE = '帐号长度在3-10位'
//密码不能为空
const PASSWORD_MESSAGE = '密码不能为空'
//登录成功提示
const WELCOME_MESSAGE = "welcome"

/**
 * actions.js
 */
//评论提示
const COMMENT_MESSAGE = 'comment success!!!'

//addCompareAction
//最多添加5条不叫数据
const COMPARE_5_TIMES_MESSAGE = 'Add up to 5 Comparisons.'
//添加成功提示
const ADD_SUCCESS_MESSAGE = 'Add success.'
//比较已存在
const COMPARE_EXISTENCE_MESSAGE = 'The comparison already exists.'
//删除成功提示
const DELETE_MESSAGE = '删除成功'

export default{
  errorCode,
  errorCode20,
  errorCode03,
  errorCode04,
  errorCode31,
  ERROR_CODE_COMPARE_REPEAT,
  COMPARE_MOST,
  ERROR_MESSAGE,
  LOGIN_NAME_MESSAGE,
  LOGIN_NAME_LENGTH_MESSAGE,
  PASSWORD_MESSAGE,
  WELCOME_MESSAGE,
  COMMENT_MESSAGE,
  COMPARE_5_TIMES_MESSAGE,
  ADD_SUCCESS_MESSAGE,
  COMPARE_EXISTENCE_MESSAGE,
  DELETE_MESSAGE
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/base/Global.vue